import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { Component, ChangeDetectionStrategy, Input, AfterViewInit, ChangeDetectorRef, EventEmitter, Output } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  standalone: true,
  selector: 'check-btn',
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './check-btn.atom.html',
  styleUrls: ['./check-btn.atom.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CheckBtnAtom {
  @Input() isRole = false;
  @Input() mode: 'checkbox' | 'radio' = 'checkbox';
  @Input() text = '';
  @Input() checked!: boolean;
  @Input() value: any;
  @Input() control = new FormControl();
  @Input() item: any;
  @Input() radioName = '';
  @Input() colorText = '';
  @Output() clicked = new EventEmitter();
  @Output() checkboxChange = new EventEmitter();
  id = Math.round(Math.random() * 10);
  constructor(private cd: ChangeDetectorRef) { }


}
